module.exports = __webpack_public_path__ + "static/media/S (3).4b2ef492.jpg";